import axiosInstance from "../libs/axiosInstance";



// Create a new course
export const createCourse = async (courseData) => {
  try {
    const response = await axiosInstance.post('/course_management/courses/', courseData);
    console.log(response);
    
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

// Get all courses (paginated)
export const getCourses = async ({
  search_text=null, department_id=null, 
  faculty_id=null, level=null, 
  include_topics=null, with_quiz=null,
  url=null
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(department_id && { department_id }),
      ...(faculty_id && { faculty_id }),
      ...(level && { level }),
      ...(include_topics && { include_topics: 1 }),
      ...(with_quiz && {with_quiz: 1})
    };
    const response = await axiosInstance.get(url || '/course_management/courses/', {
      params
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get courses for select/dropdown (non-paginated)
export const getCoursesSelect = async ({
  search_text=null,
  include_my=null,
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(include_my && { include_my: 1 }),
    };
    const response = await axiosInstance.get('/course_management/courses/select/', {
      params
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update a course
export const updateCourse = async (courseId, courseData) => {
  try {
    const response = await axiosInstance.put(`/course_management/courses/${courseId}/`, courseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a course
export const deleteCourse = async (courseId) => {
  try {
    await axiosInstance.delete(`/course_management/courses/${courseId}/`);
  } catch (error) {
    throw error;
  }
};

export const reorderCourseTopic = async (courseId, topics) => {
  try {
    await axiosInstance.post(`/course_management/courses/${courseId}/reorder-topics/`, {
      topics
    });
  } catch (error) {
    throw error;
  }
}